import React, { useEffect, useState } from 'react';
import axios from 'axios';
import baseURL from './baseUrl';

const SellArticle = () => {
  const [articles, setArticles] = useState([]);
  const [articleId, setArticleId] = useState('');
  const [pcs, setPcs] = useState('');
  const [note, setNote] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/articles`);
        setArticles(response.data || []);
      } catch (error) {
        setMessage(error.response?.data?.message || 'Failed to load articles');
      }
    };
    load();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const qty = parseFloat(pcs);
    if (!articleId || isNaN(qty) || qty <= 0) {
      setMessage('Please select article and enter valid PCS');
      return;
    }
    try {
      const response = await axios.post(`${baseURL}/api/transactions/sell/article`, {
        articleId,
        pcs: qty,
        note
      });
      setMessage(response.data.message);
      setPcs('');
      setNote('');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to sell article');
    }
  };

  return (
    <div className="container mt-4">
      <h2>Sell Article (PCS)</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit} className="card card-body shadow-sm">
        <div className="mb-3">
          <label className="form-label">Article</label>
          <select
            className="form-select"
            value={articleId}
            onChange={(e) => setArticleId(e.target.value)}
            required
          >
            <option value="">Select article</option>
            {articles.map((article) => (
              <option key={article._id} value={article._id}>
                {article.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">PCS</label>
          <input
            type="number"
            className="form-control"
            value={pcs}
            onChange={(e) => setPcs(e.target.value)}
            min="1"
            step="1"
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Note</label>
          <input
            type="text"
            className="form-control"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-danger">
          Sell from Stock
        </button>
      </form>
    </div>
  );
};

export default SellArticle;
